import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/Hyphen.svg'


const _hoisted_1 = { class: "customersSatisfactionReport" }
const _hoisted_2 = { class: "customersSatisfactionReport__chooseDate" }
const _hoisted_3 = { class: "customersSatisfactionReport__chooseDate__container" }
const _hoisted_4 = { class: "chooseDate-date-inputs" }
const _hoisted_5 = { class: "input" }
const _hoisted_6 = { class: "input" }
const _hoisted_7 = {
  key: 0,
  class: "date-error"
}
const _hoisted_8 = { class: "customersSatisfactionReport__diagrams" }
const _hoisted_9 = { class: "satisfaction-periods" }
const _hoisted_10 = { class: "thisPeriod" }
const _hoisted_11 = { class: "otherPeriod" }
const _hoisted_12 = {
  key: 1,
  class: "pie-diagram"
}
const _hoisted_13 = { class: "container" }
const _hoisted_14 = {
  key: 0,
  class: "customersSatisfactionReport__barChart"
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "customersSatisfactionReport__generalSatisfaction" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = {
  key: 0,
  class: "customersSatisfactionReport__barChart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_Description = _resolveComponent("Description")!
  const _component_Amount = _resolveComponent("Amount")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_HeatmapChart = _resolveComponent("HeatmapChart")!
  const _component_CustomersFeedbackBlock = _resolveComponent("CustomersFeedbackBlock")!
  const _component_AllFeedback = _resolveComponent("AllFeedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createBlock(_component_Calendar, {
                key: _ctx.calendarStartKey,
                type: "date",
                format: "DD/MM/YYYY",
                name: "startTime",
                value: _ctx.firstDay,
                message: _ctx.$t('errorDate'),
                onChange: _ctx.changeDateStartTime
              }, null, 8, ["value", "message", "onChange"]))
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              class: "date-img",
              src: _imports_0,
              alt: "Hyphen"
            }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createBlock(_component_Calendar, {
                key: _ctx.calendarEndKey,
                type: "date",
                format: "DD/MM/YYYY",
                name: "endTime",
                value: _ctx.today,
                onChange: _ctx.changeDateEndTime
              }, null, 8, ["value", "onChange"]))
            ])
          ]),
          _createVNode(_component_Dropdown, {
            class: "customersSatisfactionReport__thisPeriod",
            "selected-option": _ctx.getOptionThisPeriod.selectedOption,
            options: _ctx.getOptionThisPeriod.options,
            onSelectOption: _ctx.selectOptionThisPeriod
          }, null, 8, ["selected-option", "options", "onSelectOption"])
        ]),
        (!_ctx.isDateCorrect)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('errorDate')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (
          _ctx.dataLineChart &&
          _ctx.dataLineChart.labels.length &&
          (!_ctx.dataLineChart.datasets[0].data.every((value) => !value) ||
            !_ctx.dataLineChart.datasets[1].data.every((value) => !value))
        )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({
          'line-diagram': true,
          'line-diagram-long': _ctx.dataPieChart.datasets[0].data.every(
            (value) => !value
          )
        })
            }, [
              _createVNode(_component_LineChart, {
                id: 'lineChartTwoLegends',
                "data-line-chart": _ctx.dataLineChart
              }, null, 8, ["data-line-chart"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('thisPeriod')), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Dropdown, {
                    class: "customersSatisfactionReport__otherPeriod",
                    "selected-option": _ctx.getOptionOtherPeriod.selectedOption,
                    options: _ctx.getOptionOtherPeriod.options,
                    onSelectOption: _ctx.selectOptionOtherPeriod
                  }, null, 8, ["selected-option", "options", "onSelectOption"])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (
          _ctx.dataPieChart &&
          _ctx.dataPieChart.labels.length &&
          !_ctx.loading &&
          !_ctx.dataPieChart.datasets[0].data.every((value) => !value)
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_PieChart, {
                "data-pie-chart": _ctx.dataPieChart,
                style: _normalizeStyle(_ctx.stylePieChart),
                onSegmentClick: _ctx.handleSegmentClick
              }, null, 8, ["data-pie-chart", "style", "onSegmentClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Description, {
        data: _ctx.dailyStatistics?.currentPharmacyStats.textData,
        "pickup-boxes": _ctx.entityNames?.pickupBoxes,
        options: _ctx.pharmacy?.feedbackTemplate.options_screen.options
      }, null, 8, ["data", "pickup-boxes", "options"]),
      _createVNode(_component_Amount, {
        data: _ctx.dailyStatistics?.currentPharmacyStats.amountData
      }, null, 8, ["data"]),
      _createElementVNode("div", _hoisted_13, [
        (
          _ctx.dataBarChart?.labels?.length &&
          (!_ctx.dataBarChart.datasets[0].data.every((value) => !value) ||
            !_ctx.dataBarChart.datasets[1].data.every((value) => !value) ||
            !_ctx.dataBarChart.datasets[2].data.every((value) => !value))
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_BarChart, {
                id: 'barChart',
                "data-bar-chart": _ctx.dataBarChart,
                "options-bar-chart": _ctx.optionsBarChart,
                style: _normalizeStyle(_ctx.styleBarChart)
              }, null, 8, ["data-bar-chart", "options-bar-chart", "style"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_HeatmapChart, { "heatmap-data": _ctx.filteredData }, null, 8, ["heatmap-data"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (
          _ctx.dataBarChart?.labels?.length &&
          (!_ctx.dataBarChart.datasets[0].data.every((value) => !value) ||
            !_ctx.dataBarChart.datasets[1].data.every((value) => !value) ||
            !_ctx.dataBarChart.datasets[2].data.every((value) => !value))
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_BarChart, {
                id: 'barChartAmount',
                "data-bar-chart": _ctx.dataBarChartAmount,
                "options-bar-chart": _ctx.optionsBarChartAmount,
                style: _normalizeStyle(_ctx.styleBarChart)
              }, null, 8, ["data-bar-chart", "options-bar-chart", "style"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showBlockCustomersFeedbackBlock)
        ? (_openBlock(), _createBlock(_component_CustomersFeedbackBlock, {
            key: 1,
            data: _ctx.dailyStatistics?.currentPharmacyStats.comments
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AllFeedback, {
      feedback: _ctx.feedback,
      "selected-key": _ctx.selectedKey,
      "comment-key": _ctx.commentKey,
      "show-modal-all-feedback": _ctx.showModalAllFeedback,
      onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalAllFeedback = false))
    }, null, 8, ["feedback", "selected-key", "comment-key", "show-modal-all-feedback"])
  ], 64))
}